import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "liga-float-bar" }
const _hoisted_2 = { class: "liga-float-title-pill" }
const _hoisted_3 = { class: "liga-float-title-text" }
const _hoisted_4 = {
  key: 0,
  class: "empty-hint ion-padding"
}
const _hoisted_5 = {
  key: 1,
  class: "empty-hint ion-padding"
}
const _hoisted_6 = { class: "rename-hint" }
const _hoisted_7 = { class: "release-tiers-section" }
const _hoisted_8 = { class: "upload-queue-hint" }
const _hoisted_9 = { class: "upload-queue-original" }
const _hoisted_10 = ["accept"]
const _hoisted_11 = { class: "upload-modal-file-list" }
const _hoisted_12 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_13 = { class: "upload-modal-file-list" }
const _hoisted_14 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_15 = { class: "upload-modal-file-list" }
const _hoisted_16 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_17 = { class: "upload-modal-file-list" }
const _hoisted_18 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_19 = {
  key: 1,
  class: "upload-progress-list"
}
const _hoisted_20 = { class: "progress-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: _normalizeClass(["page-header liga-float-header ion-no-border", { 'page-header--scrolled': _ctx.headerScrolled }])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "page-header-toolbar" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("button", {
                  type: "button",
                  class: "liga-float-circle menu-btn",
                  "aria-label": "К списку релизов",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, [
                  _createVNode(_component_ion_icon, { icon: _ctx.arrowBackOutline }, null, 8, ["icon"])
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.pageTitle), 1)
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("div", {
                  class: "liga-float-spacer",
                  "aria-hidden": "true"
                }, null, -1))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Загрузка…"))
            : (_ctx.loadError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.loadError), 1))
              : (_ctx.selectedRelease && _ctx.selectedProgram)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_ion_card, { class: "admin-card" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_title, null, {
                              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                _createTextVNode("Названия", -1)
                              ]))]),
                              _: 1
                            }),
                            _createElementVNode("p", _hoisted_6, "Короткое имя программы (" + _toDisplayString(_ctx.selectedProgram.shortName) + ") не меняется — от него зависят папки на диске.", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_input, {
                                  label: "Название программы",
                                  "label-placement": "stacked",
                                  modelValue: _ctx.editProgramName,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editProgramName) = $event)),
                                  placeholder: "HypeDance"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _cache[18] || (_cache[18] = _createElementVNode("p", { class: "rename-hint" }, "Изменение названия программы видно у всех её релизов.", -1)),
                            _createVNode(_component_ion_button, {
                              expand: "block",
                              onClick: _ctx.saveProgramName,
                              disabled: _ctx.savingProgramName || !_ctx.canSaveProgramName
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.savingProgramName ? 'Сохранение…' : 'Сохранить название программы'), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"]),
                            _createVNode(_component_ion_item, { class: "ion-margin-top" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_input, {
                                  label: "Номер релиза",
                                  "label-placement": "stacked",
                                  modelValue: _ctx.editReleaseName,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editReleaseName) = $event)),
                                  placeholder: "1 или 10"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _cache[19] || (_cache[19] = _createElementVNode("p", { class: "rename-hint" }, "При смене номера папка на сервере переименуется (например HD_01 → HD_10).", -1)),
                            _createVNode(_component_ion_button, {
                              expand: "block",
                              onClick: _ctx.saveReleaseName,
                              disabled: _ctx.savingReleaseName || !_ctx.canSaveReleaseName
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.savingReleaseName ? 'Сохранение…' : 'Сохранить номер релиза'), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card, { class: "admin-card" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.selectedProgram.programName) + " " + _toDisplayString(_ctx.selectedRelease.releaseName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_content, { class: "release-catalog-settings" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              lines: "full",
                              class: "transparent-item"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_toggle, {
                                  modelValue: _ctx.editReleaseVisible,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editReleaseVisible) = $event))
                                }, {
                                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                    _createTextVNode("Видимый в каталоге", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, {
                              lines: "full",
                              class: "transparent-item"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_input, {
                                  modelValue: _ctx.editReleasePriceRub,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editReleasePriceRub) = $event)),
                                  modelModifiers: { number: true },
                                  label: "Цена, ₽ (0 — не продаётся отдельно; при тарифах ниже — запасной вариант)",
                                  "label-placement": "floating",
                                  type: "number",
                                  inputmode: "decimal"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_7, [
                              _cache[24] || (_cache[24] = _createElementVNode("h3", null, "Тарифы покупки", -1)),
                              _cache[25] || (_cache[25] = _createElementVNode("p", { class: "release-tiers-hint" }, "Если заданы тарифы, используется минимальная цена из доступных пользователю. Роль ограничивает видимость тарифа.", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editReleasePriceTiers, (t, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: i,
                                  class: "tier-row"
                                }, [
                                  _createVNode(_component_ion_input, {
                                    modelValue: t.name,
                                    "onUpdate:modelValue": ($event: any) => ((t.name) = $event),
                                    label: "Название",
                                    "label-placement": "stacked",
                                    placeholder: "Стандарт"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _createVNode(_component_ion_input, {
                                    modelValue: t.amountRub,
                                    "onUpdate:modelValue": ($event: any) => ((t.amountRub) = $event),
                                    modelModifiers: { number: true },
                                    label: "₽",
                                    "label-placement": "stacked",
                                    type: "number",
                                    min: "0"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _createVNode(_component_ion_select, {
                                    modelValue: t.requiredAuthorityName,
                                    "onUpdate:modelValue": ($event: any) => ((t.requiredAuthorityName) = $event),
                                    interface: "popover",
                                    placeholder: "Роль",
                                    "cancel-text": "Отмена"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_select_option, { value: null }, {
                                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                          _createTextVNode("—", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorities, (a) => {
                                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                                          key: a.name,
                                          value: a.name
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(a.description || a.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _createVNode(_component_ion_button, {
                                    fill: "clear",
                                    size: "small",
                                    onClick: ($event: any) => (_ctx.removeReleaseTier(i))
                                  }, {
                                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                      _createTextVNode("×", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]))
                              }), 128)),
                              _createVNode(_component_ion_button, {
                                fill: "outline",
                                size: "small",
                                onClick: _ctx.addReleaseTier
                              }, {
                                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                  _createTextVNode("+ Тариф", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _createVNode(_component_ion_button, {
                              expand: "block",
                              onClick: _ctx.saveReleaseCatalogSettings,
                              disabled: _ctx.savingReleaseCatalog
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.savingReleaseCatalog ? 'Сохранение…' : 'Сохранить цену и видимость'), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_content, null, {
                          default: _withCtx(() => [
                            (_ctx.uploadQueue.length > 0)
                              ? (_openBlock(), _createBlock(_component_ion_card, {
                                  key: 0,
                                  color: "tertiary",
                                  class: "upload-queue-card"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_card_header, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_card_title, null, {
                                          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                            _createTextVNode("Имена на сервере", -1)
                                          ]))]),
                                          _: 1
                                        }),
                                        _createElementVNode("p", _hoisted_8, [
                                          _cache[27] || (_cache[27] = _createTextVNode(" При необходимости измените имя каждого файла (включая ведущие нули), затем нажмите «Загрузить». ", -1)),
                                          (_ctx.uploadQueueType === 'music' || _ctx.uploadQueueType === 'video')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(" Расширение совпадает с исходным файлом и не меняется. ")
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_card_content, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_list, {
                                          lines: "full",
                                          class: "transparent-list"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadQueue, (q, qIdx) => {
                                              return (_openBlock(), _createBlock(_component_ion_item, {
                                                key: 'q-' + qIdx
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("p", _hoisted_9, _toDisplayString(q.file.name), 1),
                                                      _createVNode(_component_ion_input, {
                                                        modelValue: q.targetName,
                                                        "onUpdate:modelValue": ($event: any) => ((q.targetName) = $event),
                                                        label: "Сохранить как",
                                                        "label-placement": "stacked",
                                                        placeholder: q.file.name,
                                                        onIonInput: ($event: any) => (_ctx.onReleaseUploadTargetNameInput(q, $event))
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onIonInput"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_button, {
                                          expand: "block",
                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.flushUploadQueue())),
                                          disabled: _ctx.uploadQueueFlushing
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.uploadQueueFlushing ? 'Загрузка…' : 'Загрузить'), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["disabled"]),
                                        _createVNode(_component_ion_button, {
                                          expand: "block",
                                          fill: "clear",
                                          color: "medium",
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearUploadQueue())),
                                          disabled: _ctx.uploadQueueFlushing
                                        }, {
                                          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                            _createTextVNode(" Отмена ", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                    _createElementVNode("h2", null, "Музыка", -1),
                                    _createElementVNode("p", null, "Аудио файлы (конвертируются в MP3)", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_button, {
                              expand: "block",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectFiles('music')))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.musicalNotesOutline
                                }, null, 8, ["icon"]),
                                _cache[30] || (_cache[30] = _createTextVNode(" Загрузить музыку ", -1))
                              ]),
                              _: 1
                            }),
                            _createElementVNode("input", {
                              type: "file",
                              ref: "musicInput",
                              multiple: "",
                              accept: _ctx.adminAudioFileAccept,
                              style: {"display":"none"},
                              onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.uploadFiles('music', $event)))
                            }, null, 40, _hoisted_10),
                            _createElementVNode("div", _hoisted_11, [
                              (_ctx.releaseMediaFiles.music.length)
                                ? (_openBlock(), _createBlock(_component_ion_list, {
                                    key: 0,
                                    class: "transparent-list"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseMediaFiles.music, (f) => {
                                        return (_openBlock(), _createBlock(_component_ion_item, {
                                          key: f.id,
                                          lines: "full"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("h3", null, _toDisplayString(f.name), 1),
                                                _createElementVNode("p", null, _toDisplayString(_ctx.formatFileSize(f.weight)), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_ion_button, {
                                              slot: "end",
                                              fill: "clear",
                                              onClick: ($event: any) => (_ctx.promptRenameFile('music', f))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"]),
                                            _createVNode(_component_ion_button, {
                                              slot: "end",
                                              fill: "clear",
                                              color: "danger",
                                              onClick: ($event: any) => (_ctx.confirmDeleteFile('music', f))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }))
                                : (!_ctx.releaseMediaLoading)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Нет загруженных файлов"))
                                  : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                    _createElementVNode("h2", null, "Видео", -1),
                                    _createElementVNode("p", null, "Видео файлы (конвертируются для стриминга)", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_button, {
                              expand: "block",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectFiles('video')))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.videocamOutline
                                }, null, 8, ["icon"]),
                                _cache[32] || (_cache[32] = _createTextVNode(" Загрузить видео ", -1))
                              ]),
                              _: 1
                            }),
                            _createElementVNode("input", {
                              type: "file",
                              ref: "videoInput",
                              multiple: "",
                              accept: "video/*",
                              style: {"display":"none"},
                              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.uploadFiles('video', $event)))
                            }, null, 544),
                            _createElementVNode("div", _hoisted_13, [
                              (_ctx.releaseMediaFiles.video.length)
                                ? (_openBlock(), _createBlock(_component_ion_list, {
                                    key: 0,
                                    class: "transparent-list"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseMediaFiles.video, (f) => {
                                        return (_openBlock(), _createBlock(_component_ion_item, {
                                          key: f.id,
                                          lines: "full"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("h3", null, _toDisplayString(f.name), 1),
                                                _createElementVNode("p", null, _toDisplayString(_ctx.formatFileSize(f.weight)), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_ion_button, {
                                              slot: "end",
                                              fill: "clear",
                                              onClick: ($event: any) => (_ctx.promptRenameFile('video', f))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"]),
                                            _createVNode(_component_ion_button, {
                                              slot: "end",
                                              fill: "clear",
                                              color: "danger",
                                              onClick: ($event: any) => (_ctx.confirmDeleteFile('video', f))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }))
                                : (!_ctx.releaseMediaLoading)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Нет загруженных файлов"))
                                  : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                    _createElementVNode("h2", null, "Гайд (PDF)", -1),
                                    _createElementVNode("p", null, "PDF файл (конвертируется в изображения)", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_button, {
                              expand: "block",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectFiles('guide')))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.documentTextOutline
                                }, null, 8, ["icon"]),
                                _cache[34] || (_cache[34] = _createTextVNode(" Загрузить гайд ", -1))
                              ]),
                              _: 1
                            }),
                            _createElementVNode("input", {
                              type: "file",
                              ref: "guideInput",
                              accept: ".pdf,application/pdf",
                              style: {"display":"none"},
                              onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.uploadFiles('guide', $event)))
                            }, null, 544),
                            _createElementVNode("div", _hoisted_15, [
                              (_ctx.releaseMediaFiles.guide.length)
                                ? (_openBlock(), _createBlock(_component_ion_list, {
                                    key: 0,
                                    class: "transparent-list"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseMediaFiles.guide, (f) => {
                                        return (_openBlock(), _createBlock(_component_ion_item, {
                                          key: f.id,
                                          lines: "full"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("h3", null, _toDisplayString(f.name), 1),
                                                _createElementVNode("p", null, _toDisplayString(_ctx.formatFileSize(f.weight)), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_ion_button, {
                                              slot: "end",
                                              fill: "clear",
                                              onClick: ($event: any) => (_ctx.promptRenameFile('guide', f))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"]),
                                            _createVNode(_component_ion_button, {
                                              slot: "end",
                                              fill: "clear",
                                              color: "danger",
                                              onClick: ($event: any) => (_ctx.confirmDeleteFile('guide', f))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }))
                                : (!_ctx.releaseMediaLoading)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Нет загруженных PDF"))
                                  : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                    _createElementVNode("h2", null, "Обложка", -1),
                                    _createElementVNode("p", null, "Изображение обложки релиза", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_button, {
                              expand: "block",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectFiles('cover')))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.imageOutline
                                }, null, 8, ["icon"]),
                                _cache[36] || (_cache[36] = _createTextVNode(" Загрузить обложку ", -1))
                              ]),
                              _: 1
                            }),
                            _createElementVNode("input", {
                              type: "file",
                              ref: "coverInput",
                              accept: "image/*",
                              style: {"display":"none"},
                              onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.uploadFiles('cover', $event)))
                            }, null, 544),
                            _createElementVNode("div", _hoisted_17, [
                              (_ctx.releaseMediaFiles.cover.length)
                                ? (_openBlock(), _createBlock(_component_ion_list, {
                                    key: 0,
                                    class: "transparent-list"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseMediaFiles.cover, (f) => {
                                        return (_openBlock(), _createBlock(_component_ion_item, {
                                          key: f.id,
                                          lines: "full"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("h3", null, _toDisplayString(f.name), 1),
                                                _createElementVNode("p", null, _toDisplayString(_ctx.formatFileSize(f.weight)), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_ion_button, {
                                              slot: "end",
                                              fill: "clear",
                                              color: "danger",
                                              onClick: ($event: any) => (_ctx.confirmDeleteFile('cover', f))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }))
                                : (!_ctx.releaseMediaLoading)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, "Нет обложки"))
                                  : _createCommentVNode("", true)
                            ]),
                            (_ctx.uploadProgress.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _cache[37] || (_cache[37] = _createElementVNode("h3", null, "Загрузка файлов", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadProgress, (progress, idx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: 'progress-' + idx,
                                      class: "upload-progress-item"
                                    }, [
                                      _createElementVNode("p", null, _toDisplayString(progress.fileName), 1),
                                      _createVNode(_component_ion_progress_bar, {
                                        value: progress.percent / 100
                                      }, null, 8, ["value"]),
                                      _createElementVNode("p", _hoisted_20, _toDisplayString(progress.status), 1)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_ion_button, {
                              expand: "block",
                              fill: "outline",
                              color: "danger",
                              class: "ion-margin-top",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.confirmDeleteRelease()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.trashOutline
                                }, null, 8, ["icon"]),
                                _cache[38] || (_cache[38] = _createTextVNode(" Удалить релиз ", -1))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class", "onIonScroll"])
    ]),
    _: 1
  }))
}